import DateFnsUtils from '@date-io/date-fns';
import {
  DatePicker,
  DatePickerProps,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import { MaterialUiPickersDate } from '@material-ui/pickers/typings/date';
import frLocale from 'date-fns/locale/fr';
import { Controller, useFormContext } from 'react-hook-form';

type IDateInputRHFProps = Omit<DatePickerProps, 'name' | 'value' | 'onChange'> & {
  name: string;
};
function DateInputRHF(props: IDateInputRHFProps) {
  const { name, inputVariant = 'outlined', format = 'dd MMM yyyy' } = props;
  const {
    control,
    setValue,
    formState: { errors },
  } = useFormContext();

  const handleChange = (value: MaterialUiPickersDate) => {
    const parsedDate = value?.toISOString() ?? null;
    setValue(name, parsedDate);
  };

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils} locale={frLocale}>
      <Controller
        control={control}
        name={name}
        render={({ field: { value } }) => (
          <DatePicker
            {...props}
            format={format}
            inputVariant={inputVariant}
            onChange={(e) => handleChange(e)}
            value={value || null}
            error={Boolean(errors[name])}
            helperText={errors[name]?.message as string}
            InputLabelProps={{
              shrink: true,
            }}
          />
        )}
      />
    </MuiPickersUtilsProvider>
  );
}

export default DateInputRHF;
